import type * as Types from 'app/types/graphql';

export type ShopPlatformPlanSelectFragment = Pick<
  Types.ShopPlatformPlan,
  'id' | 'planID' | 'confirmationURL' | 'startDate' | 'endDate' | 'status'
> & {
  plan?: Types.Maybe<
    Pick<
      Types.Plan,
      | 'id'
      | 'name'
      | 'displayName'
      | 'priority'
      | 'isTrial'
      | 'basePrice'
      | 'billingCycle'
      | 'deprecated'
      | 'conditions'
      | 'createdAt'
      | 'updatedAt'
      | 'trialDays'
    >
  >;
};

export type ShopPlatformPlanEdgeSelectFragment = {
  edges?: Types.Maybe<
    Array<{
      node?: Types.Maybe<
        Pick<
          Types.ShopPlatformPlan,
          'id' | 'planID' | 'confirmationURL' | 'startDate' | 'endDate' | 'status'
        > & {
          plan?: Types.Maybe<
            Pick<
              Types.Plan,
              | 'id'
              | 'name'
              | 'displayName'
              | 'priority'
              | 'isTrial'
              | 'basePrice'
              | 'billingCycle'
              | 'deprecated'
              | 'conditions'
              | 'createdAt'
              | 'updatedAt'
              | 'trialDays'
            >
          >;
        }
      >;
    }>
  >;
};

export type ShopPlatformPlanActiveSelectFragment = Pick<
  Types.ShopPlatformPlan,
  'id' | 'planID' | 'confirmationURL' | 'startDate' | 'endDate' | 'status'
> & {
  plan?: Types.Maybe<
    Pick<
      Types.Plan,
      | 'id'
      | 'name'
      | 'displayName'
      | 'priority'
      | 'isTrial'
      | 'basePrice'
      | 'billingCycle'
      | 'deprecated'
      | 'conditions'
      | 'createdAt'
      | 'updatedAt'
      | 'trialDays'
    >
  >;
};

export type ShopPlatformPlanCreateSelectFragment = Pick<Types.ShopPlatformPlan, 'confirmationURL'>;

export type ShopPlatformPlanCancelSelectFragment = Pick<
  Types.ShopPlatformPlan,
  'id' | 'planID' | 'startDate' | 'endDate'
>;

export type ShopPlatformRevenueSelectFragment = Pick<
  Types.ShopPlatformRevenue,
  'id' | 'date' | 'totalRevenue'
>;

export const ShopPlatformPlanSelectFragmentDoc = `
    fragment ShopPlatformPlanSelect on ShopPlatformPlan {
  id
  planID
  confirmationURL
  startDate
  endDate
  status
  plan {
    ...PlanSelect
  }
}
    `;
export const ShopPlatformPlanEdgeSelectFragmentDoc = `
    fragment ShopPlatformPlanEdgeSelect on ShopPlatformPlanConnection {
  edges {
    node {
      ...ShopPlatformPlanSelect
    }
  }
}
    `;
export const ShopPlatformPlanActiveSelectFragmentDoc = `
    fragment ShopPlatformPlanActiveSelect on ShopPlatformPlan {
  ...ShopPlatformPlanSelect
}
    `;
export const ShopPlatformPlanCreateSelectFragmentDoc = `
    fragment ShopPlatformPlanCreateSelect on ShopPlatformPlan {
  confirmationURL
}
    `;
export const ShopPlatformPlanCancelSelectFragmentDoc = `
    fragment ShopPlatformPlanCancelSelect on ShopPlatformPlan {
  id
  planID
  startDate
  endDate
}
    `;
export const ShopPlatformRevenueSelectFragmentDoc = `
    fragment ShopPlatformRevenueSelect on ShopPlatformRevenue {
  id
  date
  totalRevenue
}
    `;
